import { InjectionToken } from '@angular/core';

export interface AmplitudeConfiguration {
  amplitudeDeploymentKey: string;
  amplitudeProjectKey: string;
  amplitudeSessionCaptureEnabled: boolean;
  featureFlagPollingSeconds: number;
  enableFeatureFlagPolling: boolean;
}

export const AMPLITUDE_CONFIGURATION = new InjectionToken<AmplitudeConfiguration>('AmplitudeConfiguration');
